import { coordinatesParser } from '@dolcevia/lib/searchParams';
import { Button } from '@dolcevia/ui/components/ui/button';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useQueryStates } from 'nuqs';
import { memo } from 'react';
import { Marker, Popup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { iconVillageFrance } from '../assets/marker';
import { MarkerClusterIcon } from '../marker-cluster-icon';
import type { useMapPointOfInterests } from '../useMapPointOfInterests';
const VillagesMarkerContent = ({
  villages,
  isVillageDisplayed,
}: {
  villages: ReturnType<typeof useMapPointOfInterests>['data'];
  isVillageDisplayed: boolean;
}) => {
  const [{ coordinates }, setParams] = useQueryStates({
    coordinates: coordinatesParser,
  });
  const t = useTranslations('Home.Map');
  return (
    <MarkerClusterGroup
      chunkedLoading
      iconCreateFunction={() => MarkerClusterIcon(iconVillageFrance)}
    >
      {isVillageDisplayed &&
        villages?.map((village, index) => (
          <Marker
            icon={iconVillageFrance}
            key={index}
            position={[village.lat, village.lng]}
          >
            <Popup>
              <div className="flex flex-col gap-4">
                <p>{village.name}</p>
                <Image
                  unoptimized
                  src={village.image}
                  alt={village.name}
                  width={560}
                  height={500}
                  className="rounded-lg"
                />
                {coordinates.every((el) => el.title !== village.name) && (
                  <Button
                    className="button-marker"
                    onClick={async () => {
                      await setParams((prev) => {
                        const newCoordinates = prev.coordinates ?? [];
                        newCoordinates.splice(newCoordinates.length - 1, 0, {
                          lat: village.lat,
                          lng: village.lng,
                          title: village.name,
                        });

                        return {
                          ...prev,
                          coordinates: newCoordinates,
                        };
                      });
                    }}
                  >
                    {t('Passer par ce village')}
                  </Button>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
    </MarkerClusterGroup>
  );
};

export const VillagesMarker = memo(VillagesMarkerContent);
